var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEnforce8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2051_977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.99999C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20.2497C24 21.5977 23.3211 22.855 22.1939 23.5943L14.5461 28.611C13.2531 29.4592 11.587 29.4861 10.2673 28.6801L1.91517 23.5793C0.7256 22.8528 0 21.5594 0 20.1655V3.99999Z",
    fill: "url(#paint0_linear_2051_977)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47913 15.72H6.14313V13.352H3.82313V11.144H6.14313V8.808H8.47913V11.144H10.7991V13.352H8.47913V15.72ZM18.3693 6.28V10.92L17.2333 12.072L18.3693 13.224V18.424L17.2333 19.56H12.7213L11.5693 18.424V13.208L12.7053 12.072L11.5693 10.92V6.28L12.7053 5.128H17.2333L18.3693 6.28ZM14.2413 17.352H15.6813L15.9693 17.08V13.448L15.6813 13.192H14.2413L13.9693 13.448V17.08L14.2413 17.352ZM14.2413 10.984H15.6813L15.9693 10.712V7.592L15.6813 7.336H14.2413L13.9693 7.592V10.712L14.2413 10.984Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2051_977",
    x: -1,
    y: -1,
    width: 25,
    height: 30.2666,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2051_977"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2051_977",
    x1: 3.24888e-7,
    y1: 0.428571,
    x2: 24,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FECC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEnforce8);
export default __webpack_public_path__ + "static/media/ic_enforce_8.bc44f3ac33a9ec288032c94b10ccd03b.svg";
export { ForwardRef as ReactComponent };